<div class="preview-container">

  <!-- Image Preview -->
  <div *ngIf="fileIconResult.type == FileCategory.Image" class="media-preview image-preview">
    <div class="media-wrapper" [class.loading]="!mediaLoaded">
      <!-- Placeholder layer: icona + spinner -->
      <div *ngIf="!mediaLoaded" class="placeholder-layer">
        <img class="placeholder-icon"
            [src]="fileIconResult.url"
            alt="Loading...">

        <img class="placeholder-spinner"
            src="assets/images/imgLoad.svg"
            alt="Loading...">
      </div>
      <!-- Image layer -->
      <img
        [src]="message.content"
        loading="lazy"
        class="lazy-media lazy-img"
        [class.loaded]="mediaLoaded"
        (load)="onLoadImage($event)"
        (click)="openImagePreview(message.content)"
        [matTooltip]="'TTP.VIEWIMAGE' | translate"
        />
      <div class="filename-label">{{message.fileName}}</div>
    </div>
  </div>

  <!-- Video Preview - Static Icon (no video loading until fullscreen) -->
  <div *ngIf="fileIconResult.type == FileCategory.Video" class="media-preview video-preview">
    <div class="video-static-preview"
         (click)="!disabled && openVideoPreview(message.content)"
         [class.disabled]="disabled"
         [matTooltip]="'TTP.VIEWVIDEO' | translate">

      <!-- Video icon -->
      <img class="video-icon"
           [src]="fileIconResult.url"
           alt="Video">

      <!-- Play button overlay -->
      <div class="play-button-overlay">
        <span class="material-symbols-outlined">play_circle</span>
      </div>

      <!-- File name -->
      <div class="video-filename" *ngIf="message.fileName">
        {{ message.fileName }}
      </div>
    </div>
  </div>

  <!-- Audio Preview -->
  <div *ngIf="fileIconResult.type == FileCategory.Audio" class="media-preview audio-preview">
    <div class="media-wrapper" [class.loading]="!mediaLoaded">
      <!-- Placeholder layer: icona + spinner -->
      <img *ngIf="!mediaLoaded"
           class="placeholder-icon"
           [src]="fileIconResult.url"
           alt="Loading...">

      <img *ngIf="!mediaLoaded"
           class="placeholder-spinner"
           src="assets/images/imgLoad.svg"
           alt="Loading...">

      <!-- Audio layer -->
      <audio
        [src]="message.content"
        preload="metadata"
        class="lazy-media lazy-audio"
        [class.loaded]="mediaLoaded"
        (loadedmetadata)="onLoadAudio($event)"
        [ngClass]="{'disabled-media': disabled}"
        controls
        [matTooltip]="'TTP.PLAYAUDIO' | translate"
        >
      </audio>
    </div>
  </div>

</div>